import { contactInfo } from '@/mocks/homeData';

export default function Contact() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              {contactInfo.title}
            </h2>
            <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">
              {contactInfo.desc}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
            <div className="bg-background-50 rounded-xl p-6 md:p-8 text-center">
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600">
                <i className="ri-mail-line text-2xl"></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-800 mb-2">爆料邮箱</h3>
              <p className="text-sm text-foreground-600 mb-1">{contactInfo.email}</p>
              <p className="text-xs text-foreground-500">24小时内回复</p>
            </div>

            <div className="bg-background-50 rounded-xl p-6 md:p-8 text-center">
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600">
                <i className="ri-wechat-line text-2xl"></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-800 mb-2">微信联系</h3>
              <p className="text-sm text-foreground-600 mb-1">{contactInfo.wechat}</p>
              <p className="text-xs text-foreground-500">工作日在线</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}